import React from 'react';
import Helmet from 'react-helmet';


export default function({
  title = 'Finwhale',
  description,
}) {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
}



// WEBPACK FOOTER //
// ./src/basic/Meta.js